// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__75eCI","inner":"Footer_inner__1KR7H","nextIcon":"Footer_nextIcon__2nnHr","innerLeft":"Footer_innerLeft__JFOA1"};